// Logs de diagnostico: ativar no console com
//   localStorage.setItem('umabala_debug', '1')  e recarregar a pagina.
// Erros e avisos continuam sempre visiveis.
const UB_DEBUG_CART = (() => {
  try { return localStorage.getItem('umabala_debug') === '1'; } catch (e) { return false; }
})();

// VERSÃO FINAL CORRIGIDA - assets/cart-drawer.js

// Funções de suporte do tema para garantir estabilidade
function trapFocus(container, elementToFocus = container) {
  var elements = Array.from(container.querySelectorAll("summary, a[href], button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='number']:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex='-1'])"));
  var first = elements[0]; var last = elements[elements.length - 1];
  removeTrapFocus();
  var focusinListener = (event) => { if (event.target !== container && event.target !== last && event.target !== first) first.focus(); };
  var keydownListener = (event) => { if (event.code.toUpperCase() === 'TAB') { if (event.target === last && !event.shiftKey) { event.preventDefault(); first.focus(); } if (event.target === first && event.shiftKey) { event.preventDefault(); last.focus(); } } };
  document.addEventListener('focusin', focusinListener);
  document.addEventListener('keydown', keydownListener);
  if (elementToFocus) elementToFocus.focus();
  window.currentTrapFocus = { focusin: focusinListener, keydown: keydownListener };
}
function removeTrapFocus(elementToFocus = null) {
  if (window.currentTrapFocus) {
    document.removeEventListener('focusin', window.currentTrapFocus.focusin);
    document.removeEventListener('keydown', window.currentTrapFocus.keydown);
  }
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


// Onde recortar a foto na miniatura da grade. O zoom mostra uma faixa estreita
// da imagem; no meio de uma foto de corpo inteiro isso cai na calca quando a
// peca e uma blusa (e vice-versa). O product_type esta vazio em toda a loja,
// entao a peca e identificada pela primeira palavra do titulo.
const UB_PECAS_DE_CIMA = ['regata','blusa','cropped','camisa','camiseta','jaqueta','colete','casaco','blazer','body','top','bata','tricot','cardiga'];
const UB_PECAS_DE_BAIXO = ['calca','saia','short','shorts','bermuda','pantacourt','pantalona','legging','jogger'];

function ubRecorteDaPeca(titulo) {
  if (!titulo) return 'meio';
  const primeira = String(titulo)
    .trim()
    .split(/\s+/)[0]
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, ''); // remove acento: "calça" -> "calca"

  if (UB_PECAS_DE_CIMA.includes(primeira)) return 'cima';
  if (UB_PECAS_DE_BAIXO.includes(primeira)) return 'baixo';
  return 'meio';
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
  }

  // Função helper para aguardar elemento aparecer no DOM
  async waitForElement(selector, timeout = 5000, interval = 100) {
    const startTime = Date.now();
    while (Date.now() - startTime < timeout) {
      const element = document.querySelector(selector);
      if (element) {
        return element;
      }
      await new Promise(resolve => setTimeout(resolve, interval));
    }
    return null;
  }

  // Função helper para garantir que badge do carrinho existe
  async ensureCartBadgeExists() {
    let cartIconBubble = document.getElementById('cart-icon-bubble');
    
    // Se não existe, aguardar aparecer
    if (!cartIconBubble) {
      UB_DEBUG_CART && console.log('⏳ Aguardando cart-icon-bubble aparecer no DOM...');
      cartIconBubble = await this.waitForElement('#cart-icon-bubble', 3000);
    }
    
    if (!cartIconBubble) {
      console.warn('⚠️ cart-icon-bubble não encontrado após timeout');
      return null;
    }
    
    // Verificar se o bubble existe dentro do cart-icon-bubble
    let bubble = cartIconBubble.querySelector('.cart-count-bubble');
    if (!bubble) {
      // Criar o bubble dinamicamente se não existir
      UB_DEBUG_CART && console.log('🔧 Criando cart-count-bubble dinamicamente...');
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = '0';
      bubble.appendChild(span);
      cartIconBubble.appendChild(bubble);
    }
    
    // Garantir que o span existe dentro do bubble
    let countSpan = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
    if (!countSpan) {
      countSpan = document.createElement('span');
      countSpan.setAttribute('aria-hidden', 'true');
      countSpan.textContent = '0';
      bubble.appendChild(countSpan);
    }
    
    return { cartIconBubble, bubble, countSpan };
  }

  // Função helper para garantir que itemsContainer existe antes de renderizar
  async ensureItemsContainerExists() {
    let itemsContainer = document.getElementById('matrix-cart-items-container');
    
    // Se não existe, aguardar aparecer
    if (!itemsContainer) {
      UB_DEBUG_CART && console.log('⏳ Aguardando matrix-cart-items-container aparecer no DOM...');
      itemsContainer = await this.waitForElement('#matrix-cart-items-container', 5000);
    }
    
    if (!itemsContainer) {
      console.error('❌ matrix-cart-items-container não encontrado após timeout');
      console.error('🔍 Tentando encontrar elementos relacionados...');
      const cartDrawer = document.querySelector('cart-drawer');
      const cartItems = document.getElementById('CartDrawer-CartItems');
      console.error('cart-drawer existe?', !!cartDrawer);
      console.error('CartDrawer-CartItems existe?', !!cartItems);
      
      // Tentar criar o container se não existir (último recurso)
      if (cartItems) {
        UB_DEBUG_CART && console.log('🔧 Tentando criar matrix-cart-items-container dinamicamente...');
        const wrapper = cartItems.querySelector('.drawer__cart-items-wrapper');
        if (wrapper) {
          itemsContainer = document.createElement('div');
          itemsContainer.id = 'matrix-cart-items-container';
          wrapper.appendChild(itemsContainer);
          UB_DEBUG_CART && console.log('✅ matrix-cart-items-container criado dinamicamente!');
        }
      }
    }
    
    if (!itemsContainer) {
      console.error('❌ Não foi possível encontrar ou criar matrix-cart-items-container');
      return null;
    }
    
    UB_DEBUG_CART && console.log('✅ matrix-cart-items-container encontrado/criado:', itemsContainer);
    return itemsContainer;
  }

  connectedCallback() {
    UB_DEBUG_CART && console.log('🔍 DEBUG: CartDrawer connectedCallback chamado!');
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    
    // Configurar o link do carrinho na inicialização
    UB_DEBUG_CART && console.log('🔍 DEBUG: Configurando cart icon...');
    this.setHeaderCartIconAccessibility();
    
    // Reconfigurar após um tempo para garantir que pegue
    setTimeout(() => this.setHeaderCartIconAccessibility(), 100);
    setTimeout(() => this.setHeaderCartIconAccessibility(), 500);
    
    // Envio IMEDIATO com coalescencia (mesmo padrao da pagina do produto):
    // enquanto uma requisicao esta em voo, novos cliques ficam acumulados por
    // variante e saem juntos assim que ela volta. Sem atraso artificial.
    this.pendingCartQuantities = {};
    this.cartUpdateInFlight = false;
    this.debouncedUpdateCart = (variantId, quantity, lineItemId = null) => {
      if (!variantId) return;
      this.pendingCartQuantities[variantId] = { quantity: Number(quantity), lineItemId };
      this.flushCartQueue();
    };
    
    // Escutar atualizações do carrinho de outras fontes (product page)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
        // CRÍTICO: Ignorar eventos do próprio cart-drawer para evitar loop infinito
        // Ignorar: 'cart-drawer', 'matrix-cart-empty', e qualquer source que comece com 'matrix-cart-'
        const isInternalEvent = event.source === 'cart-drawer' || 
                                event.source === 'matrix-cart-empty' || 
                                (event.source && event.source.startsWith('matrix-cart-'));
        
        if (!isInternalEvent && event.cartData) {
          UB_DEBUG_CART && console.log('🔄 Cart drawer recebeu atualização externa de:', event.source);
          await this.renderMatrixGrid(event.cartData);
        } else {
          UB_DEBUG_CART && console.log('⏭️ Cart drawer ignorando evento interno:', event.source);
        }
      });
    }
    
    // CRÍTICO: Inicializar carrinho imediatamente para garantir estado correto
    // Isso garante que o drawer está pronto antes de qualquer evento ser disparado
    this.initializeCartDrawer();
    
    this.isInitialized = true;
    UB_DEBUG_CART && console.log('✅ DEBUG: CartDrawer inicializado e pronto!');
  }

  // Método para inicializar o carrinho imediatamente
  async initializeCartDrawer() {
    UB_DEBUG_CART && console.log('🔄 Inicializando carrinho no cart-drawer...');
    
    // CRÍTICO: Aguardar container existir antes de renderizar
    const itemsContainer = await this.ensureItemsContainerExists();
    if (!itemsContainer) {
      console.warn('⚠️ Container não encontrado na inicialização, tentando novamente em 300ms...');
      setTimeout(() => this.initializeCartDrawer(), 300);
      return;
    }
    
    try {
      // Buscar estado atual do carrinho
      const response = await fetch('/cart.js');
      if (response.ok) {
        const cartData = await response.json();
        UB_DEBUG_CART && console.log('✅ Carrinho carregado na inicialização:', cartData);
        UB_DEBUG_CART && console.log('🔍 DEBUG: Itens no carrinho:', cartData.items?.length || 0);
        // Renderizar grid matrix com dados atuais
        await this.renderMatrixGrid(cartData);
      } else {
        console.error('❌ Erro ao buscar carrinho na inicialização:', response.status);
      }
    } catch (error) {
      console.error('⚠️ Erro ao inicializar carrinho:', error);
    }
  }

  disconnectedCallback() {
    // Limpar subscriber quando elemento for destruído
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) {
      // Se não encontrou, pode ser que o elemento ainda não foi renderizado
      // Isso acontece quando o sticky bar é renderizado depois do cart-drawer
      return;
    }
    
    // Evitar adicionar listeners múltiplos
    if (cartLink.dataset.cartDrawerConfigured === 'true') {
      return;
    }
    
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.dataset.cartDrawerConfigured = 'true';
    
    // Remover href para evitar navegação se ainda existir
    if (cartLink.hasAttribute('href')) {
      cartLink.addEventListener('click', (event) => { 
        event.preventDefault(); 
        this.open(cartLink); 
      });
    } else {
      // Se não tem href, adicionar listener normalmente
      cartLink.addEventListener('click', (event) => { 
        event.preventDefault(); 
        this.open(cartLink); 
      });
    }
    
    cartLink.addEventListener('keydown', (event) => { 
      if (event.code.toUpperCase() === 'SPACE') { 
        event.preventDefault(); 
        this.open(cartLink); 
      } 
    });
  }

  async open(triggeredBy) {
    UB_DEBUG_CART && console.log('🔍 DEBUG: open() chamado! triggeredBy:', triggeredBy);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // Adicionar classes primeiro para mostrar o drawer
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
    
    // Esqueleto enquanto o carrinho carrega, para nao exibir um vao em branco
    this.showLoadingSkeleton();

    UB_DEBUG_CART && console.log('🔍 DEBUG: Buscando carrinho atualizado...');
    // SEMPRE buscar carrinho atualizado ao abrir para garantir dados corretos
    try {
      const response = await fetch('/cart.js');
      if (response.ok) {
        const cartData = await response.json();
        // Guardar para que o grid da pagina do produto reaproveite esta
        // resposta em vez de disparar um segundo /cart.js logo em seguida.
        this.lastCartData = cartData;
        UB_DEBUG_CART && console.log('🔍 DEBUG: Carrinho carregado no open():', cartData);
        // Garantir que renderiza com await para esperar completar
        await this.renderMatrixGrid(cartData);
      } else {
        UB_DEBUG_CART && console.log('⚠️ DEBUG: Erro ao buscar carrinho, tentando renderizar sem dados');
        await this.renderMatrixGrid();
      }
    } catch (error) {
      console.error('⚠️ DEBUG: Erro ao buscar carrinho:', error);
      await this.renderMatrixGrid();
    }
    
    UB_DEBUG_CART && console.log('✅ DEBUG: Drawer aberto e renderizado!');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  
  renderContents(parsedState) {
    this.renderMatrixGrid(parsedState);
  }

  // ===== BUSCAR SWATCH DE COR NATIVO DO SHOPIFY =====
  // Os swatches são buscados UMA VEZ por produto e reaproveitados para todas
  // as cores. Antes, cada cor sem swatch refazia as 3 tentativas de rede a
  // cada renderização, o que travava a abertura do carrinho por segundos.
  async getColorSwatch(productHandle, colorName) {
    if (!productHandle || !colorName) {
      console.warn('⚠️ getColorSwatch: parâmetros inválidos', { productHandle, colorName });
      return this.getColorSwatchFallback(colorName);
    }

    const swatches = await this.ensureProductSwatches(productHandle);

    if (swatches) {
      const swatch = this.findSwatchInData(swatches, colorName);
      if (swatch && swatch.type) {
        return this.formatSwatchStyle(swatch);
      }
    }

    // Cor sem swatch cadastrado: usar fallback SEM refazer requisição
    return this.getColorSwatchFallback(colorName);
  }

  // Garante que os swatches do produto foram buscados uma única vez.
  // Guarda também o resultado negativo (null) para não tentar de novo.
  async ensureProductSwatches(productHandle) {
    if (!this.swatchesCache) this.swatchesCache = {};
    if (!this.swatchesPending) this.swatchesPending = {};

    if (Object.prototype.hasOwnProperty.call(this.swatchesCache, productHandle)) {
      return this.swatchesCache[productHandle];
    }

    // Requisição já em andamento para este produto: reaproveitar a promise
    if (this.swatchesPending[productHandle]) {
      return this.swatchesPending[productHandle];
    }

    this.swatchesPending[productHandle] = (async () => {
      let swatches = null;
      try {
        swatches = await this.fetchProductSwatches(productHandle);
      } catch (error) {
        console.error(`❌ Erro ao buscar swatches de ${productHandle}:`, error);
      }
      this.swatchesCache[productHandle] = swatches;
      delete this.swatchesPending[productHandle];
      return swatches;
    })();

    return this.swatchesPending[productHandle];
  }

  // Tenta os 3 métodos em sequência e devolve os swatches do produto (ou null)
  async fetchProductSwatches(productHandle) {
    // MÉTODO 1: Buscar via section_id com product_handle na query string
    try {
      const swatchUrl = `/products/${productHandle}?section_id=product-swatches&product_handle=${encodeURIComponent(productHandle)}`;
      const swatchResponse = await fetch(swatchUrl);

      if (swatchResponse.ok) {
        const text = await swatchResponse.text();

        let swatchData = null;
        try {
          swatchData = JSON.parse(text.trim());
        } catch (parseError) {
          // Tentar extrair JSON do HTML (pode estar dentro de div ou script tag)
          const jsonMatches = [
            text.match(/\{[\s\S]*?"swatches"[\s\S]*?\}/),
            text.match(/<script[^>]*type=["']application\/json["'][^>]*>([\s\S]*?)<\/script>/i),
            text.match(/<div[^>]*>(\{[\s\S]*?"swatches"[\s\S]*?\})<\/div>/i)
          ];

          for (const match of jsonMatches) {
            if (match) {
              try {
                swatchData = JSON.parse((match[1] || match[0]).trim());
                break;
              } catch (e) {
                // Continuar tentando
              }
            }
          }
        }

        if (swatchData && swatchData.swatches && !swatchData.error) {
          UB_DEBUG_CART && console.log(`✅ [Método 1] Swatches carregados para ${productHandle}`);
          return swatchData.swatches;
        }
      }
    } catch (error) {
      console.error(`❌ [Método 1] Erro ao buscar swatches:`, error);
    }

    // MÉTODO 2: Tentar via template JSON (se existir)
    try {
      const templateResponse = await fetch(`/products/${productHandle}.swatches.json`);
      if (templateResponse.ok) {
        const contentType = templateResponse.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const swatchData = await templateResponse.json();
          if (swatchData && swatchData.swatches && !swatchData.error) {
            UB_DEBUG_CART && console.log(`✅ [Método 2] Swatches carregados para ${productHandle}`);
            return swatchData.swatches;
          }
        }
      }
    } catch (error) {
      UB_DEBUG_CART && console.log(`⚠️ [Método 2] Template JSON não disponível:`, error.message);
    }

    // MÉTODO 3: Tentar via view=swatches (fallback)
    try {
      const viewResponse = await fetch(`/products/${productHandle}?view=swatches`);
      if (viewResponse.ok) {
        const text = await viewResponse.text();
        const jsonMatch = text.match(/\{[\s\S]*?"swatches"[\s\S]*?\}/);
        if (jsonMatch) {
          try {
            const swatchData = JSON.parse(jsonMatch[0]);
            if (swatchData && swatchData.swatches) {
              UB_DEBUG_CART && console.log(`✅ [Método 3] Swatches carregados para ${productHandle}`);
              return swatchData.swatches;
            }
          } catch (e) {
            // Ignorar
          }
        }
      }
    } catch (error) {
      UB_DEBUG_CART && console.log(`⚠️ [Método 3] view=swatches não disponível:`, error.message);
    }

    console.warn(`⚠️ Nenhum swatch encontrado para ${productHandle}, usando fallback de cores`);
    return null;
  }

  // ===== HELPER: Buscar swatch nos dados =====
  findSwatchInData(swatchesData, colorName) {
    if (!swatchesData || !colorName) {
      return null;
    }
    
    // Normalizar nome da cor (remover espaços extras, trim)
    const normalizedColorName = String(colorName).trim();
    
    // Iterar sobre todas as opções de cor
    for (const optionName in swatchesData) {
      const optionSwatches = swatchesData[optionName];
      if (!optionSwatches || typeof optionSwatches !== 'object') continue;
      
      // Tentar match exato primeiro
      if (optionSwatches[normalizedColorName]) {
        return optionSwatches[normalizedColorName];
      }
      
      // Tentar case-insensitive
      for (const key in optionSwatches) {
        if (key.trim().toLowerCase() === normalizedColorName.toLowerCase()) {
          return optionSwatches[key];
        }
      }
      
      // Tentar match parcial (para casos onde há diferenças de acentuação ou espaços)
      for (const key in optionSwatches) {
        const normalizedKey = key.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const normalizedSearch = normalizedColorName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        if (normalizedKey === normalizedSearch) {
          return optionSwatches[key];
        }
      }
    }
    
    return null;
  }

  // ===== HELPER: Formatar estilo do swatch (igual ao tema Dawn) =====
  formatSwatchStyle(swatch) {
    if (!swatch || !swatch.type) {
      return 'background-color: #CCCCCC;';
    }
    
    if (swatch.type === 'image') {
      let style = `background-image: url(${swatch.image}); background-size: cover; background-position: center;`;
      if (swatch.focal_point) {
        style = `background-image: url(${swatch.image}); background-size: cover; background-position: ${swatch.focal_point};`;
      }
      return style;
    } else if (swatch.type === 'color') {
      // Usa rgb() como o tema Dawn faz (snippets/swatch.liquid linha 21)
      return `background-color: rgb(${swatch.rgb});`;
    }
    
    return 'background-color: #CCCCCC;';
  }

  // ===== FALLBACK: Lógica antiga =====
  getColorSwatchFallback(colorName) {
    if (!colorName) {
      return 'background-color: #CCCCCC;';
    }
    
    const value = String(colorName).trim();
    if (value.startsWith('#')) {
      return `background-color: ${value};`;
    }
    
    return `background-color: ${value.toLowerCase()};`;
  }

  // Esqueleto de carregamento: so aparece quando ainda nao ha grade na tela,
  // evitando piscar por cima de um carrinho ja renderizado.
  showLoadingSkeleton() {
    const itemsContainer = document.getElementById('matrix-cart-items-container');
    if (!itemsContainer) return;
    if (itemsContainer.querySelector('.matrix-grid')) return;

    if (!document.getElementById('matrix-skeleton-style')) {
      const style = document.createElement('style');
      style.id = 'matrix-skeleton-style';
      style.textContent = `
        @keyframes matrix-skeleton-pulse { 0%,100% { opacity: .55; } 50% { opacity: .25; } }
        .matrix-skeleton { padding: 1rem 0; }
        .matrix-skeleton__bar { background: currentColor; border-radius: 4px; animation: matrix-skeleton-pulse 1.2s ease-in-out infinite; }
        .matrix-skeleton__head { display: flex; align-items: center; gap: .75rem; margin-bottom: 1rem; }
        .matrix-skeleton__row { display: flex; align-items: center; gap: .5rem; margin-bottom: .5rem; }
      `;
      document.head.appendChild(style);
    }

    let html = '<div class="matrix-skeleton" aria-hidden="true">';
    html += '<div class="matrix-skeleton__head">';
    html += '<div class="matrix-skeleton__bar" style="width:56px;height:56px;border-radius:6px;"></div>';
    html += '<div class="matrix-skeleton__bar" style="width:55%;height:14px;"></div>';
    html += '</div>';
    for (let r = 0; r < 5; r++) {
      html += '<div class="matrix-skeleton__row">';
      html += '<div class="matrix-skeleton__bar" style="width:22px;height:22px;border-radius:50%;"></div>';
      html += '<div class="matrix-skeleton__bar" style="width:70px;height:12px;"></div>';
      for (let c = 0; c < 4; c++) {
        html += '<div class="matrix-skeleton__bar" style="flex:1;height:12px;"></div>';
      }
      html += '</div>';
    }
    html += '</div>';

    itemsContainer.innerHTML = html;
  }

  async renderMatrixGrid(cartData) {
    // Guardar o ultimo carrinho conhecido para reuso entre componentes
    if (cartData && cartData.items) this.lastCartData = cartData;

    // CRÍTICO: Garantir que itemsContainer existe antes de renderizar
    const itemsContainer = await this.ensureItemsContainerExists();
    if (!itemsContainer) {
      console.error('❌ Não foi possível encontrar itemsContainer, tentando novamente em 200ms...');
      // Retry após um delay
      setTimeout(() => this.renderMatrixGrid(cartData), 200);
      return;
    }
    
    UB_DEBUG_CART && console.log('✅ itemsContainer encontrado, prosseguindo com renderização...');
    
    let cart = cartData;
    
    // CRÍTICO: Detectar se cartData é um ITEM único (retornado por /cart/add.js) 
    // ou um CARRINHO completo (retornado por /cart.js ou /cart/change.js)
    // Um item único tem propriedades como 'id', 'variant_id', 'quantity' mas NÃO tem 'items' array
    const isSingleItem = cart && cart.id && cart.variant_id && !cart.items;
    
    if (isSingleItem) {
      console.warn('⚠️ cartData é um ITEM único, não um carrinho completo. Buscando carrinho completo...');
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) {
          console.error('❌ Erro ao buscar carrinho completo após receber item único');
          return;
        }
        cart = await response.json();
        UB_DEBUG_CART && console.log('✅ Carrinho completo buscado:', cart);
      } catch (error) {
        console.error('❌ Erro ao buscar carrinho completo:', error);
        return;
      }
    } else if (!cart) {
      // Se não receber cartData, buscar do endpoint correto
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) return;
        cart = await response.json();
        UB_DEBUG_CART && console.log('🔍 DEBUG: Carrinho buscado via fetch:', cart);
      } catch (error) {
        console.error('Erro ao carregar carrinho:', error);
        return;
      }
    }
    
    // CRÍTICO: Calcular item_count REAL baseado na soma das quantidades dos itens
    // Isso corrige inconsistência onde cart.item_count pode ser 0 mas cart.items tem itens
    const actualItemCount = cart && cart.items && Array.isArray(cart.items) 
      ? cart.items.reduce((total, item) => total + (item.quantity || 0), 0)
      : 0;
    
    // Corrigir cart.item_count se estiver inconsistente
    if (actualItemCount !== (cart.item_count || 0)) {
      console.warn('⚠️ INCONSISTÊNCIA DETECTADA: cart.item_count =', cart.item_count, 'mas actualItemCount =', actualItemCount);
      cart.item_count = actualItemCount;
    }
    
    UB_DEBUG_CART && console.log('🔍 DEBUG: actualItemCount calculado:', actualItemCount, '| cart.item_count:', cart.item_count);
    
    if (!cart || !cart.items || actualItemCount === 0) {
      UB_DEBUG_CART && console.log('🔍 DEBUG: Carrinho vazio ou sem itens (actualItemCount = 0)');
      itemsContainer.innerHTML = ''; 
      this.classList.add('is-empty');
      
      // Atualizar total e contador para zero
      const totalValueElement = document.getElementById('CartDrawer-TotalValue');
      if (totalValueElement) totalValueElement.textContent = 'R$ 0,00';
      const itemCountElement = document.getElementById('CartDrawer-ItemCount');
      if (itemCountElement) itemCountElement.textContent = '0';
      
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        const countElement = cartIconBubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (countElement) countElement.textContent = '0';
        cartIconBubble.classList.remove('cart-count-bubble--visible');
      }
      
      if (cart) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'matrix-cart-empty', cartData: cart }); 
      return;
    }
    UB_DEBUG_CART && console.log('🔍 DEBUG: Carrinho tem', cart.items.length, 'itens');
    
    // CRÍTICO: Remover classe is-empty e garantir que conteúdo está visível
    this.classList.remove('is-empty');
    
    // CRÍTICO: Garantir que drawer__inner-empty está oculto e cart-drawer-items está visível
    const drawerInnerEmpty = this.querySelector('.drawer__inner-empty');
    if (drawerInnerEmpty) {
      drawerInnerEmpty.style.display = 'none';
      UB_DEBUG_CART && console.log('✅ drawer__inner-empty ocultado');
    }
    
    // Garantir que cart-drawer-items não tem classe is-empty
    const cartDrawerItems = this.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.classList.remove('is-empty');
      UB_DEBUG_CART && console.log('✅ cart-drawer-items.is-empty removido');
    }
    
    const sizeOrder = ['PP', 'P', 'M', 'G', 'GG', 'XG', '34', '36', '38', '40', '42', '44', '46', '48', '50'];
    
    // Agrupar produtos do carrinho por product_id
    // Usar Set para garantir que não há duplicatas de product_id
    const seenProductIds = new Set();
    const groupedDataMap = cart.items.reduce((acc, item) => {
      if (!acc[item.product_id]) {
        acc[item.product_id] = { 
          product_title: item.product_title, 
          product_url: item.url, 
          product_id: item.product_id, 
          product_handle: item.handle, 
          variants: [] 
        };
        seenProductIds.add(item.product_id);
      }
      acc[item.product_id].variants.push(item);
      return acc;
    }, {});
    
    // Converter para array e ordenar alfabeticamente pelo título do produto
    // A ordenação alfabética garante ordem fixa e consistente, independente de quando variantes são adicionadas
    const groupedData = Object.values(groupedDataMap)
      .filter(product => product && product.product_title) // Garantir que não há valores inválidos
      .sort((a, b) => {
        // Ordenação alfabética usando localeCompare para suportar acentos e caracteres especiais
        return a.product_title.localeCompare(b.product_title, 'pt-BR', { 
          sensitivity: 'base', 
          ignorePunctuation: true,
          numeric: true 
        });
      });
    let html = '';
    
    // Processar cada produto do carrinho
    for (const product of groupedData) {
      const firstVariant = product.variants[0];
      if (!firstVariant || !firstVariant.options_with_values) continue;
      
      // BUSCAR TODAS AS VARIANTES DO PRODUTO (não apenas as do carrinho)
      let allProductVariants = [];
      let productData = null;
      try {
        const productHandle = product.product_handle;
        UB_DEBUG_CART && console.log(`🔍 Buscando produto completo: ${productHandle}`);
        const productResponse = await fetch(`/products/${productHandle}.js`);
        if (productResponse.ok) {
          productData = await productResponse.json();
          allProductVariants = productData.variants || [];
          UB_DEBUG_CART && console.log(`✅ Produto completo carregado: ${allProductVariants.length} variantes`);
        }
      } catch (error) {
        console.error('Erro ao buscar produto completo:', error);
      }
      
      // Se não conseguiu buscar, usa apenas as do carrinho
      if (allProductVariants.length === 0) {
        UB_DEBUG_CART && console.log('⚠️ Usando apenas variantes do carrinho');
        allProductVariants = product.variants;
      }
      
      const optionNames = firstVariant.options_with_values.map(opt => opt.name);
      if (optionNames.length < 2) continue;
      
      // Obter TODAS as cores e tamanhos do produto (não apenas do carrinho)
      const allRowValues = [...new Set(allProductVariants.map(v => v.option1))].filter(Boolean);
      const allSizes = [...new Set(allProductVariants.map(v => v.option2))].filter(val => val && sizeOrder.includes(val));
      allSizes.sort((a, b) => sizeOrder.indexOf(a) - sizeOrder.indexOf(b));
      
      UB_DEBUG_CART && console.log(`🔍 DEBUG PRODUTO: "${product.product_title}"`);
      UB_DEBUG_CART && console.log(`🔍 DEBUG: TODAS as cores:`, allRowValues);
      UB_DEBUG_CART && console.log(`🔍 DEBUG: TODOS os tamanhos:`, allSizes);
      
      // Usar primeira imagem do produto (productData.featured_image ou productData.images[0])
      let imageUrl = '';
      if (productData) {
        if (productData.featured_image) {
          imageUrl = productData.featured_image.replace(/(\.jpg|\.png|\.jpeg|\.gif)/, '_100x100$&');
        } else if (productData.images && productData.images.length > 0) {
          imageUrl = productData.images[0].replace(/(\.jpg|\.png|\.jpeg|\.gif)/, '_100x100$&');
        }
      }
      // Fallback para primeira variante se produto completo não foi encontrado
      if (!imageUrl && firstVariant.featured_image) {
        imageUrl = firstVariant.featured_image.url.replace(/(\.jpg|\.png|\.jpeg|\.gif)/, '_100x100$&');
      }
      
      const rowOptionName = optionNames[0]; 
      const colOptionName = optionNames[1];
      
      html += `<div class="matrix-product" data-product-id="${product.product_id}">`;
      html += `<div class="matrix-product-header-wrapper">`;
      html += `<a href="${product.product_url}" class="matrix-product-link"><div class="matrix-product-header"><img src="${imageUrl}" class="matrix-product-header-img" alt="${product.product_title}"><h3 class="matrix-product-header-title">${product.product_title}</h3></div></a>`;
      html += `<button class="matrix-product-remove" title="Remover todas as quantidades deste produto" aria-label="Remover ${product.product_title}">`;
      html += `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>`;
      html += `</button>`;
      html += `</div>`;
      html += `<table class="matrix-grid">`;
      html += `<thead><tr>`;
      html += `<th class="matrix-col-color">&nbsp;</th>`;
      allSizes.forEach(size => { 
        html += `<th class="matrix-col-size">${size}</th>`; 
      });
      html += `</tr></thead>`;
      html += `<tbody>`;
      
      // Buscar swatches para todas as cores antes de renderizar
      const colorSwatches = {};
      UB_DEBUG_CART && console.log(`🎨 Buscando swatches para ${allRowValues.length} cores do produto "${product.product_title}"`);
      
      // Em paralelo: a busca de rede acontece uma vez so por produto
      // (ensureProductSwatches), as demais cores resolvem em memoria.
      await Promise.all(allRowValues.map(async (rowValue) => {
        try {
          colorSwatches[rowValue] = await this.getColorSwatch(product.product_handle, rowValue);
        } catch (error) {
          console.error(`❌ Erro ao buscar swatch para "${rowValue}":`, error);
          colorSwatches[rowValue] = 'background-color: #CCCCCC;'; // Fallback cinza
        }
      }));
      
      UB_DEBUG_CART && console.log(`🎨 Swatches carregados:`, Object.keys(colorSwatches).length, 'de', allRowValues.length);

      // Foto por cor: primeira variante daquela cor que tenha imagem propria.
      // Serve para exibir a miniatura no lugar da bolinha.
      const colorThumbs = {};
      allRowValues.forEach((rowValue) => {
        const comFoto = allProductVariants.find(
          (v) => v.option1 === rowValue && v.featured_image && (v.featured_image.src || v.featured_image.url)
        );
        if (!comFoto) return;
        const bruto = comFoto.featured_image.src || comFoto.featured_image.url;
        // Mesma convencao de redimensionamento usada no cabecalho do produto
        colorThumbs[rowValue] = bruto.replace(/(\.jpg|\.png|\.jpeg|\.gif|\.webp)/i, '_500x$&');
      });
      
      allRowValues.forEach(rowValue => {
        const swatchStyle = colorSwatches[rowValue] || 'background-color: #CCCCCC;';
        
        // Validar que o estilo não está vazio
        const finalStyle = swatchStyle.trim() || 'background-color: #CCCCCC;';
        
        html += `<tr>`;
        html += `<td class="matrix-col-color matrix-cell-row-header" style="white-space: nowrap; overflow: hidden;">`;
        // Retangulo unico: filete da cor a esquerda + recorte ampliado da foto.
        // O filete e necessario porque o zoom pega o meio da imagem e, numa
        // blusa, isso cai na calca (e vice-versa) - a cor real ficava ambigua.
        const thumbUrl = colorThumbs[rowValue];
        const recorte = ubRecorteDaPeca(product.product_title);
        if (thumbUrl) {
          html += `<span class="cart-color-chip cart-color-chip--${recorte}" style="${finalStyle}" title="${rowValue}"><span class="cart-color-chip__photo"><img src="${thumbUrl}" alt="Detalhe da cor ${rowValue}" loading="lazy"></span></span>`;
        } else {
          html += `<span class="cart-color-chip" style="${finalStyle}" title="${rowValue}"></span>`;
        }
        html += `<span class="visually-hidden">${rowValue}</span>`;
        html += `</td>`;
        
        allSizes.forEach(colValue => {
          // Buscar variante COMPLETA (do produto)
          const fullVariant = allProductVariants.find(v => v.option1 === rowValue && v.option2 === colValue);
          
          // Buscar variante no carrinho (para pegar quantity)
          const cartVariant = product.variants.find(va => {
            const rowOpt = va.options_with_values.find(o => o.name === rowOptionName);
            const colOpt = va.options_with_values.find(o => o.name === colOptionName);
            return rowOpt?.value === rowValue && colOpt?.value === colValue;
          });
          
          html += `<td class="matrix-col-size">`;
          
          if (!fullVariant) {
            // Variante não existe no produto
            html += `<div class="matrix-cell-empty">-</div>`;
          } else if (!fullVariant.available) {
            // Sem estoque
            html += `<div class="quantity-input-out-of-stock" title="Indisponível">-</div>`;
          } else {
            // Com estoque - mostrar input com wrapper para mensagem
            const currentQty = cartVariant ? cartVariant.quantity : 0;
            const inventoryQty = fullVariant.inventory_quantity || null;
            const maxStock = inventoryQty !== null && inventoryQty > 0 ? inventoryQty : 9999;
            
            html += `<div class="quantity-cell-wrapper" style="position: relative;">`;
            
            if (cartVariant) {
              // Variante está no carrinho - usar line item id
              html += `<input type="number" class="quantity-input ${currentQty === 0 ? 'quantity-zero' : ''}" value="${currentQty}" min="0" max="${maxStock}" data-variant-id="${cartVariant.variant_id}" data-line-item-id="${cartVariant.id}" data-max-stock="${maxStock}" data-inventory-quantity="${inventoryQty || ''}" />`;
            } else {
              // Variante NÃO está no carrinho - usar variant id apenas
              html += `<input type="number" class="quantity-input quantity-zero" value="0" min="0" max="${maxStock}" data-variant-id="${fullVariant.id}" data-max-stock="${maxStock}" data-inventory-quantity="${inventoryQty || ''}" readonly />`;
            }
            
            html += `</div>`;
          }
          
          html += `</td>`;
        });
        html += `</tr>`;
      });
      html += `</tbody></table>`;
    }
    
    // Logs de debug antes de inserir HTML
    UB_DEBUG_CART && console.log('🔍 DEBUG: HTML gerado com sucesso');
    UB_DEBUG_CART && console.log('🔍 DEBUG: HTML length:', html.length);
    UB_DEBUG_CART && console.log('🔍 DEBUG: Quantidade de produtos processados:', groupedData.length);
    UB_DEBUG_CART && console.log('🔍 DEBUG: itemsContainer antes de inserir:', itemsContainer);
    UB_DEBUG_CART && console.log('🔍 DEBUG: itemsContainer existe?', !!itemsContainer);
    UB_DEBUG_CART && console.log('🔍 DEBUG: itemsContainer.parentElement:', itemsContainer?.parentElement);
    
    if (html.length === 0) {
      console.warn('⚠️ AVISO: HTML vazio! Nenhum produto foi renderizado.');
      console.warn('🔍 DEBUG: groupedData:', groupedData);
      console.warn('🔍 DEBUG: cart.items:', cart.items);
    }
    
    // Inserir HTML no DOM
    itemsContainer.innerHTML = html;
    
    // Logs de debug após inserir HTML
    UB_DEBUG_CART && console.log('✅ HTML inserido no DOM com sucesso!');
    UB_DEBUG_CART && console.log('🔍 DEBUG: itemsContainer.innerHTML.length após inserção:', itemsContainer.innerHTML.length);
    
    // Verificar se elementos foram criados
    const products = itemsContainer.querySelectorAll('.matrix-product');
    UB_DEBUG_CART && console.log('🔍 DEBUG: Produtos encontrados no DOM:', products.length);
    
    // VERIFICAR OS VALORES NO DOM
    const inputsAfterInsert = itemsContainer.querySelectorAll('.quantity-input');
    UB_DEBUG_CART && console.log(`🔍 DEBUG: Total de inputs encontrados após inserção: ${inputsAfterInsert.length}`);
    
    if (inputsAfterInsert.length === 0) {
      console.error('❌ ERRO CRÍTICO: Nenhum input encontrado após inserção!');
      console.error('🔍 DEBUG: Verificando estrutura do HTML gerado...');
      console.error('🔍 DEBUG: Primeiros 1000 caracteres do HTML:', html.substring(0, 1000));
      console.error('🔍 DEBUG: itemsContainer.innerHTML existe?', !!itemsContainer.innerHTML);
      console.error('🔍 DEBUG: itemsContainer.innerHTML.length:', itemsContainer.innerHTML.length);
      
      // Verificar se há algum problema com a estrutura
      const tables = itemsContainer.querySelectorAll('table.matrix-grid');
      const products = itemsContainer.querySelectorAll('.matrix-product');
      console.error('🔍 DEBUG: Tabelas encontradas:', tables.length);
      console.error('🔍 DEBUG: Produtos encontrados:', products.length);
    } else {
      UB_DEBUG_CART && console.log('✅ Inputs encontrados com sucesso!');
      // Log apenas dos primeiros 5 inputs para não poluir o console
      // Converter NodeList para Array para poder usar slice
      const inputsArray = Array.from(inputsAfterInsert);
      inputsArray.slice(0, 5).forEach((i, index) => {
        UB_DEBUG_CART && console.log(`🔍 DEBUG DOM [${index}]: Input value="${i.value}" variant=${i.dataset.variantId} lineItem=${i.dataset.lineItemId || 'null'}`);
      });
      if (inputsAfterInsert.length > 5) {
        UB_DEBUG_CART && console.log(`🔍 DEBUG: ... e mais ${inputsAfterInsert.length - 5} inputs`);
      }
    }
    
    // Event listeners para inputs
    itemsContainer.querySelectorAll('.quantity-input').forEach(i => {
        // Change event
        i.addEventListener('change', (e) => { 
          e.stopPropagation(); 
          const lineItemId = e.target.dataset.lineItemId || null;
          this.debouncedUpdateCart(e.target.dataset.variantId, e.target.value, lineItemId); 
        });
        
        // Flag para distinguir entre desktop e mobile
        let isTouchDevice = false;
        
        // ===== DESKTOP: Mouse Events =====
        i.addEventListener('mousedown', (e) => {
          if (isTouchDevice) return; // Ignorar se for touch device
          this.handleCartLongPressStart(i, e);
        });
        
        i.addEventListener('mouseup', (e) => {
          if (isTouchDevice) return;
          this.handleCartLongPressEnd(i);
          
          // Se NÃO foi long-press, incrementar
          if (!this.wasLongPress) {
            this.handleCartInputClick(i);
          }
          this.wasLongPress = false;
        });
        
        i.addEventListener('mouseleave', () => {
          if (isTouchDevice) return;
          this.handleCartLongPressEnd(i);
          this.wasLongPress = false;
        });
        
        // ===== MOBILE: Touch Events =====
        let touchStartX = 0;
        let touchStartY = 0;
        let touchMoved = false;
        const TOUCH_MOVE_THRESHOLD = 10; // pixels para considerar movimento
        
        i.addEventListener('touchstart', (e) => {
          isTouchDevice = true;
          const touch = e.touches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchMoved = false;
          
          // Só prevenir default se não estiver em scroll
          if (e.target === i) {
            e.preventDefault();
          }
          
          this.handleCartLongPressStart(i, e);
        }, { passive: false });
        
        i.addEventListener('touchmove', (e) => {
          if (!touchMoved && e.touches.length > 0) {
            const touch = e.touches[0];
            const deltaX = Math.abs(touch.clientX - touchStartX);
            const deltaY = Math.abs(touch.clientY - touchStartY);
            
            if (deltaX > TOUCH_MOVE_THRESHOLD || deltaY > TOUCH_MOVE_THRESHOLD) {
              touchMoved = true;
              // Cancelar long-press se usuário estiver deslizando
              this.handleCartLongPressEnd(i);
            }
          }
        }, { passive: true });
        
        i.addEventListener('touchend', (e) => {
          // Só processar se foi um toque válido (não scroll)
          if (!touchMoved) {
            e.preventDefault(); // Prevenir click fantasma apenas se não foi scroll
          }
          
          this.handleCartLongPressEnd(i);
          
          // Se NÃO foi long-press e NÃO foi movimento, incrementar
          if (!this.wasLongPress && !touchMoved) {
            this.handleCartInputClick(i);
          }
          this.wasLongPress = false;
          touchMoved = false;
        }, { passive: false });
        
        i.addEventListener('touchcancel', (e) => {
          // Usuário deslizou para fora - cancelar long-press
          this.handleCartLongPressEnd(i);
          this.wasLongPress = false;
          touchMoved = false;
        });
        
        // Prevenir foco e edição direta
        i.addEventListener('focus', (e) => {
          e.preventDefault();
          i.blur();
        });
        
        // Prevenir teclado
        i.addEventListener('keydown', (e) => {
          e.preventDefault();
          return false;
        });
      });
      
      // Event listeners para botões de remover
      itemsContainer.querySelectorAll('.matrix-product-remove').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // CRÍTICO: Obter o container do produto específico e seu product_id
          const productContainer = btn.closest('.matrix-product');
          if (!productContainer) {
            console.error('❌ Container do produto não encontrado');
            return;
          }
          
          const productId = productContainer.dataset.productId;
          if (!productId) {
            console.error('❌ product_id não encontrado no container');
            return;
          }
          
          UB_DEBUG_CART && console.log(`🗑️ Removendo produto específico: product_id=${productId}`);
          
          // Buscar apenas inputs dentro deste produto específico
          const inputs = productContainer.querySelectorAll('.quantity-input');
          
          // Coletar todos os line item IDs que precisam ser zerados
          // CRÍTICO: Garantir que estamos coletando apenas do produto específico
          const updates = {};
          const inputsToUpdate = [];
          
          for (const input of inputs) {
            const currentValue = parseInt(input.value) || 0;
            if (currentValue > 0) {
              const lineItemId = input.dataset.lineItemId;
              
              if (lineItemId) {
                // Item está no carrinho - adicionar ao objeto de updates
                // Verificar se o lineItemId pertence ao produto correto
                updates[lineItemId] = 0;
                UB_DEBUG_CART && console.log(`✅ Adicionando lineItemId ${lineItemId} ao objeto de updates`);
              }
              
              // Marcar input para atualização de UI
              inputsToUpdate.push(input);
            }
          }
          
          UB_DEBUG_CART && console.log(`📦 Total de itens a remover: ${Object.keys(updates).length} do produto ${productId}`);
          
          // Atualizar UI imediatamente (zerar todos os inputs)
          inputsToUpdate.forEach(input => {
            input.value = 0;
            input.classList.remove('quantity-max-stock', 'cart-error');
            this.removeMaxStockMessage(input);
          });
          
          // Se há itens no carrinho para remover, fazer uma única chamada à API
          if (Object.keys(updates).length > 0) {
            this.classList.add('is-loading');
            
            try {
              // CRÍTICO: Verificar se os line item IDs pertencem ao produto correto
              // Buscar carrinho atual para validar
              const currentCartResponse = await fetch('/cart.js');
              if (currentCartResponse.ok) {
                const currentCart = await currentCartResponse.json();
                const validatedUpdates = {};
                
                // Filtrar apenas line item IDs que pertencem ao produto específico
                for (const lineItemId in updates) {
                  const cartItem = currentCart.items.find(item => item.id.toString() === lineItemId);
                  if (cartItem && cartItem.product_id.toString() === productId) {
                    validatedUpdates[lineItemId] = 0;
                    UB_DEBUG_CART && console.log(`✅ Validado: lineItemId ${lineItemId} pertence ao produto ${productId}`);
                  } else {
                    console.warn(`⚠️ Ignorado: lineItemId ${lineItemId} não pertence ao produto ${productId}`);
                  }
                }
                
                if (Object.keys(validatedUpdates).length === 0) {
                  console.warn('⚠️ Nenhum item válido para remover após validação');
                  this.classList.remove('is-loading');
                  return;
                }
                
                UB_DEBUG_CART && console.log(`📤 Removendo ${Object.keys(validatedUpdates).length} itens do produto ${productId}`);
                
                const response = await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates: validatedUpdates })
                });
                
                if (response.ok) {
                  const cartState = await response.json();
                  
                  // Re-renderizar a grade para garantir sincronização completa
                  await this.renderMatrixGrid(cartState);
                  
                  // Publicar evento de atualização
                  if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, { 
                      source: 'cart-drawer-remove-product', 
                      cartData: cartState 
                    });
                  }
                } else {
                  console.error('❌ Erro ao remover itens do carrinho');
                  // Em caso de erro, recarregar carrinho
                  await this.renderMatrixGrid();
                }
              } else {
                console.error('❌ Erro ao buscar carrinho para validação');
                // Em caso de erro, recarregar carrinho
                await this.renderMatrixGrid();
              }
            } catch (error) {
              console.error('❌ Erro ao remover itens do carrinho:', error);
              // Em caso de erro, recarregar carrinho
              await this.renderMatrixGrid();
            } finally {
              this.classList.remove('is-loading');
            }
          }
        });
      });
    
    // ===== ATUALIZAR TOTAL E CONTADOR SEMPRE APÓS RENDERIZAR =====
    // Usar função centralizada para garantir consistência e evitar race conditions
    await this.updateTotalsAndBadge(cart);
    UB_DEBUG_CART && console.log('✅ Total, contador e ícone do carrinho atualizados!');
  }

  handleCartInputClick(input) {
    if (input.disabled || input.classList.contains('out-of-stock')) return;
    
    const currentValue = parseInt(input.value) || 0;
    const maxStock = parseInt(input.dataset.maxStock) || 9999;
    const newValue = Math.min(currentValue + 1, maxStock);
    
    input.value = newValue;
    
    // CRÍTICO: NÃO verificar estoque máximo aqui - isso será feito em updateCart()
    // após receber a resposta da API, que tem o estoque real do carrinho
    // Remover qualquer mensagem anterior para evitar confusão
    input.classList.remove('quantity-max-stock');
    this.removeMaxStockMessage(input);
    
    // Atualizar carrinho - a verificação de estoque máximo será feita lá
    const lineItemId = input.dataset.lineItemId || null;
    this.debouncedUpdateCart(input.dataset.variantId, newValue, lineItemId);
    
    // Animação visual de feedback
    input.classList.add('quantity-clicked');
    setTimeout(() => {
      input.classList.remove('quantity-clicked');
    }, 200);
  }

  handleCartLongPressStart(input, event) {
    if (input.disabled || input.classList.contains('out-of-stock')) return;
    
    this.wasLongPress = false;
    
    // Salvar valor original para feedback háptico
    const originalValue = parseInt(input.value) || 0;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    this.longPressTimer = setTimeout(() => {
      this.wasLongPress = true; // Marcar que foi long-press para não incrementar no click
      
      const newValue = 0;
      input.value = newValue;
      input.classList.remove('quantity-max-stock', 'cart-error');
      this.removeMaxStockMessage(input);
      
      // Feedback háptico quando quantidade é zerada (apenas se tinha valor antes e foi realmente zerado)
      if (originalValue > 0 && newValue === 0 && isTouchDevice) {
        // Padrão de vibração mais perceptível
        if ('vibrate' in navigator) {
          try {
            navigator.vibrate([30, 50, 30]);
          } catch (e) {
            // Ignorar erros de vibração
          }
        }
      }
      
      // Atualizar carrinho
      const lineItemId = input.dataset.lineItemId || null;
      this.debouncedUpdateCart(input.dataset.variantId, 0, lineItemId);
      
      // Feedback visual
      input.classList.add('quantity-reset');
      setTimeout(() => {
        input.classList.remove('quantity-reset');
      }, 300);
    }, 400); // Delay otimizado para melhor UX mobile
  }

  handleCartLongPressEnd(input) {
    if (this.longPressTimer) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = null;
    }
  }

  // Função para verificar limite de estoque - REMOVIDA
  // NÃO CHAMAR checkStockLimit no cart drawer após renderização
  // A mensagem só deve aparecer quando Shopify retorna erro 422 (estoque insuficiente)
  checkStockLimit(input, quantity) {
    // DESABILITADA - não fazer nada
    // A mensagem de estoque máximo será tratada apenas em caso de erro 422
    return;
  }

  showMaxStockMessage(input, maxStock) {
    // Remover mensagem anterior se existir
    this.removeMaxStockMessage(input);
    
    // Criar ou atualizar mensagem tipo toast/popup
    let messageEl = input.parentElement.querySelector('.max-stock-message');
    if (!messageEl) {
      messageEl = document.createElement('div');
      messageEl.className = 'max-stock-message';
      messageEl.style.cssText = `
        position: absolute;
        top: -30px;
        left: 50%;
        transform: translateX(-50%);
        background: #e74c3c;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 0.7rem;
        white-space: nowrap;
        z-index: 1000;
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
      `;
      input.parentElement.appendChild(messageEl);
    }
    
    messageEl.textContent = 'MÁXIMO DISPONÍVEL';
    messageEl.style.display = 'block';
    messageEl.style.fontSize = '0.9rem'; // Aumentar tamanho
    messageEl.style.fontWeight = '700'; // Bold
    
    // Animar aparecimento
    setTimeout(() => {
      messageEl.style.opacity = '1';
    }, 10);
    
    // Auto-remover após 2 segundos
    setTimeout(() => {
      this.removeMaxStockMessage(input);
    }, 2000);
  }

  removeMaxStockMessage(input) {
    const messageEl = input.parentElement.querySelector('.max-stock-message');
    if (messageEl) {
      messageEl.style.opacity = '0';
      setTimeout(() => {
        messageEl.style.display = 'none';
      }, 300);
    }
  }

  // Função para atualizar apenas o badge do carrinho (pode ser chamada assincronamente)
  async updateCartBadge(itemCount) {
    // Garantir que badge existe (com retry logic e criação dinâmica se necessário)
    const badgeElements = await this.ensureCartBadgeExists();
    
    if (!badgeElements) {
      // Se ainda não conseguiu, tentar novamente após um delay
      setTimeout(() => this.updateCartBadge(itemCount), 200);
      return;
    }
    
    const { cartIconBubble, bubble, countSpan } = badgeElements;
    
    // Atualizar contador
    if (countSpan) {
      countSpan.textContent = itemCount;
      UB_DEBUG_CART && console.log('✅ Badge do carrinho atualizado para:', itemCount);
    }
    
    // Garantir que o bubble está visível se houver itens
    if (bubble) {
      if (itemCount > 0) {
        cartIconBubble.classList.add('cart-count-bubble--visible');
        bubble.style.display = '';
      } else {
        cartIconBubble.classList.remove('cart-count-bubble--visible');
        bubble.style.display = 'none';
      }
    }
    
    // Atualizar aria-label
    cartIconBubble.setAttribute('aria-label', `Carrinho com ${itemCount} item${itemCount !== 1 ? 's' : ''}`);
  }

  // Função centralizada para atualizar totais, contador e badge do carrinho
  async updateTotalsAndBadge(cartState) {
    if (!cartState) return;
    
    // CRÍTICO: Calcular item_count REAL para evitar inconsistências
    const actualItemCount = cartState && cartState.items && Array.isArray(cartState.items)
      ? cartState.items.reduce((total, item) => total + (item.quantity || 0), 0)
      : (cartState.item_count || 0);
    
    // Corrigir cartState.item_count se estiver inconsistente
    if (actualItemCount !== (cartState.item_count || 0)) {
      console.warn('⚠️ updateTotalsAndBadge: Corrigindo item_count de', cartState.item_count, 'para', actualItemCount);
      cartState.item_count = actualItemCount;
    }
    
    // Atualizar total do carrinho
    const totalValueElement = document.getElementById('CartDrawer-TotalValue');
    if (totalValueElement) {
      const priceInCents = cartState.total_price || 0;
      const currency = cartState.currency || 'BRL';
      const formattedPrice = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol'
      }).format(priceInCents / 100);
      totalValueElement.textContent = formattedPrice;
    }

    // Atualizar contador de itens no drawer (usar actualItemCount calculado)
    const itemCountElement = document.getElementById('CartDrawer-ItemCount');
    if (itemCountElement) {
      itemCountElement.textContent = actualItemCount;
    }

    // Atualizar badge do carrinho no header (usar actualItemCount calculado)
    // CRÍTICO: Garantir que badge existe antes de atualizar (async)
    await this.updateCartBadge(actualItemCount);
    
    // Atualizar botão de checkout (validação de 12 peças) - usar actualItemCount
    const checkoutButton = document.getElementById('CartDrawer-Checkout');
    const minicartMessage = document.getElementById('CartDrawer-MinicartMessage');
    const MINIMUM_ITEMS = 12;
    
    if (checkoutButton) {
      if (actualItemCount >= MINIMUM_ITEMS) {
        checkoutButton.disabled = false;
        checkoutButton.classList.remove('disabled');
        if (minicartMessage) {
          minicartMessage.textContent = '';
          minicartMessage.style.display = 'none';
          minicartMessage.style.marginTop = '0';
          minicartMessage.style.height = '0';
        }
      } else {
        checkoutButton.disabled = true;
        checkoutButton.classList.add('disabled');
        if (minicartMessage && actualItemCount > 0) {
          const remaining = MINIMUM_ITEMS - actualItemCount;
          minicartMessage.textContent = `Faltam ${remaining} peça${remaining !== 1 ? 's' : ''} para atingir a compra mínima`;
          minicartMessage.style.display = 'block';
          minicartMessage.style.marginTop = '0rem';
          minicartMessage.style.height = 'auto';
        }
      }
    }
  }

  // Envia as quantidades pendentes uma de cada vez, sem sobreposicao.
  // Cliques repetidos na mesma celula viram UMA requisicao com o valor final.
  async flushCartQueue() {
    if (this.cartUpdateInFlight) return;

    const entries = Object.entries(this.pendingCartQuantities);
    if (entries.length === 0) return;
    this.pendingCartQuantities = {};

    this.cartUpdateInFlight = true;
    try {
      for (const [variantId, info] of entries) {
        await this.updateCart(variantId, info.quantity, info.lineItemId);
      }
    } catch (error) {
      console.error('Erro ao processar fila do carrinho:', error);
    } finally {
      this.cartUpdateInFlight = false;
    }

    // Clicou durante a requisicao? Enviar agora o valor final acumulado.
    if (Object.keys(this.pendingCartQuantities).length > 0) {
      this.flushCartQueue();
    }
  }

  async updateCart(variantIdOrLineItemId, requestedQuantity, providedLineItemId = null) {
    if (!variantIdOrLineItemId) return;
    this.classList.add('is-loading'); // Efeito visual de carregamento
    
    // Declarar inputField UMA VEZ no início para usar em toda a função
    let inputField = this.querySelector(`.quantity-input[data-variant-id="${variantIdOrLineItemId}"], .quantity-input[data-line-item-id="${variantIdOrLineItemId}"]`);

    try {
      // USAR lineItemId passado diretamente, não buscar no DOM
      const lineItemId = providedLineItemId || (inputField ? inputField.dataset.lineItemId : null);
      
      // /cart/update.js grava a quantidade ABSOLUTA da variante e devolve o
      // carrinho completo. Substitui o par add.js/change.js: add.js SOMAVA,
      // entao dois cliques rapidos antes da grade re-renderizar (quando o
      // lineItemId ainda era null) gravavam quantidade a mais no carrinho.
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [variantIdOrLineItemId]: Number(requestedQuantity) } })
      });

      let cartState;
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        
        // Se for erro 422 (estoque insuficiente), Shopify já adicionou o máximo disponível
        if (response.status === 422) {
          UB_DEBUG_CART && console.log('⚠️ Estoque insuficiente (422), buscando estado atual do carrinho...');
          // Buscar o estado atualizado do carrinho
          const cartResponse = await fetch('/cart.js');
          if (!cartResponse.ok) {
            console.error('Erro ao buscar carrinho após 422');
            this.classList.remove('is-loading');
            return;
          }
          cartState = await cartResponse.json();
          
          // Encontrar a quantidade que realmente foi adicionada/atualizada
          const updatedItem = cartState.items.find(item => 
            item.id.toString() === lineItemId || item.variant_id.toString() === variantIdOrLineItemId.toString()
          );
          
          // Se inputField não existir mais, re-buscar após re-render
          if (!inputField) {
            // Aguardar re-render completar
            await new Promise(resolve => setTimeout(resolve, 100));
            inputField = this.querySelector(`[data-variant-id="${variantIdOrLineItemId}"]`);
          }
          
          if (updatedItem && inputField) {
            inputField.value = updatedItem.quantity;
            inputField.classList.add('quantity-max-stock');
            this.showMaxStockMessage(inputField, updatedItem.quantity);
            setTimeout(() => {
              inputField.classList.remove('quantity-max-stock');
            }, 3000);
          }
          
          // Re-renderizar o carrinho completo com os dados atualizados
          await this.renderMatrixGrid(cartState);
          this.classList.remove('is-loading');
          publish(PUB_SUB_EVENTS.cartUpdate, { 
            source: 'cart-drawer', 
            cartData: cartState
          });
          return; // Sair aqui para evitar processar o resto
        } else {
          throw new Error(errorData.description || `Erro HTTP: ${response.status}`);
        }
      } else {
        cartState = await response.json();
      }

      // Se cartState não foi definido (erro sem tratamento específico), não continuar
      if (!cartState) {
        this.classList.remove('is-loading');
        return;
      }

      // ----- SEMPRE RE-RENDERIZAR A GRADE PARA GARANTIR SINCRONIZAÇÃO COMPLETA -----
      await this.renderMatrixGrid(cartState);

      // ----- LÓGICA SIMPLIFICADA: Mensagem só aparece quando realmente ultrapassou o limite -----
      // Se requestedQuantity > actualQuantity, significa que Shopify limitou a quantidade
      // CRÍTICO: NÃO mostrar mensagem se actualQuantity for 0 (item não foi adicionado ainda ou não existe)
      if (response.ok) {
        const updatedItem = cartState && cartState.items ? 
          cartState.items.find(item => item.id.toString() === lineItemId || item.variant_id.toString() === variantIdOrLineItemId.toString()) : null;
        const actualQuantity = updatedItem ? updatedItem.quantity : 0;
        
        // Só mostrar mensagem se solicitou mais do que foi adicionado E actualQuantity > 0
        // Se actualQuantity é 0, significa que item não foi encontrado ou não foi adicionado
        if (Number(requestedQuantity) > 0 && 
            actualQuantity > 0 && 
            Number(requestedQuantity) > actualQuantity) {
          // Re-buscar o inputField após renderização (inputs foram re-criados)
          const newInputField = this.querySelector(`.quantity-input[data-variant-id="${variantIdOrLineItemId}"], .quantity-input[data-line-item-id="${lineItemId}"]`);
          
          if (newInputField) {
            newInputField.value = actualQuantity; // Corrige o valor para o máximo disponível
            newInputField.classList.add('cart-error', 'quantity-max-stock');
            this.showMaxStockMessage(newInputField, actualQuantity);
            setTimeout(() => { 
              newInputField.classList.remove('cart-error');
            }, 2500);
          }
        }
      }

      // Avisa outros componentes do tema sobre a atualização
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: cartState });

    } catch (e) {
      console.error('Erro ao atualizar o carrinho:', e);
      
      // Mostrar mensagem de erro visual para o usuário (inputField já declarado no início)
      if (inputField) {
        inputField.classList.add('cart-error');
        
        // Criar ou mostrar mensagem de erro
        let errorMsg = document.getElementById('cart-error-message');
        if (!errorMsg) {
          errorMsg = document.createElement('div');
          errorMsg.id = 'cart-error-message';
          errorMsg.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #e74c3c; color: white; padding: 15px 20px; border-radius: 5px; z-index: 9999; box-shadow: 0 2px 10px rgba(0,0,0,0.2);';
          errorMsg.textContent = 'Erro ao atualizar quantidade. Tente novamente.';
          document.body.appendChild(errorMsg);
          
          setTimeout(() => {
            errorMsg.remove();
          }, 3000);
        }
        
        setTimeout(() => { 
          inputField.classList.remove('cart-error');
        }, 2500);
      }
    } finally {
      this.classList.remove('is-loading');
    }
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  getSectionInnerHTML(html, selector) { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML; }
  setActiveElement(element) { this.activeElement = element; }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

